import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const About = () => {
  useEffect(() => {
    document.title = "About | Stelcore Development";
  }, []);

  return (
    <div data-testid="about-page">
      <section>
        <div className="container-x py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <Reveal>
              <SectionLabel>About Stelcore</SectionLabel>
              <h1 className="text-4xl sm:text-5xl tracking-tighter font-bold uppercase mt-6" data-testid="about-headline">
                Development with a clear strategy.
              </h1>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal delay={0.1}>
              <p className="text-base text-graphite leading-relaxed mb-6">
                Stelcore Development is a privately owned Eastern Ontario real estate development
                company focused on identifying strategic opportunities and creating value through
                thoughtful acquisition, planning, and development.
              </p>
              <p className="text-base text-graphite leading-relaxed mb-6">
                We take a formal approach to evaluating properties, understanding their potential,
                and advancing projects that create lasting value.
              </p>
              <p className="text-base text-graphite leading-relaxed">
                Stelcore's credibility is demonstrated through real projects, professional documentation
                and a clear development process.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="border-b border-ink/10">
        <div className="container-x py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionLabel>Geographic Focus</SectionLabel>
              <h2 className="text-3xl sm:text-4xl tracking-tight font-semibold uppercase mt-6">
                Eastern Ontario
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.1}>
              <p className="text-base text-graphite leading-relaxed mb-8">
                Stelcore's work is centred on Eastern Ontario, where growing communities, settlement-area
                expansion and infrastructure investment continue to shape real estate development opportunities.
              </p>
              <Link to="/projects" className="btn-secondary" data-testid="about-cta-projects">
                View Our Projects <ArrowRight size={14} />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-ink text-bone">
        <div className="container-x py-20 md:py-24 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <SectionLabel dark>Invest With Us</SectionLabel>
            <h2 className="text-2xl sm:text-3xl tracking-tight font-semibold uppercase mt-4">
              Have a property opportunity?
            </h2>
          </div>
          <Link to="/invest-with-us#submit" className="btn-light shrink-0" data-testid="about-cta-invest">
            Discuss Your Property <ArrowRight size={14} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
